export class HeaderData {
    public name: String;
    public class: String;
    public filter: String;
    public hidden: boolean = false;
    constructor(private namestr: String, private classstr: String, private filterstr: String, hiddenstr: boolean) {
        this.name = namestr;
        this.class = classstr;
        this.filter = filterstr;
        this.hidden = hiddenstr;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/headerdata .ts